import { ElementType, IElement } from "../../../models/Element";

export interface QuestionItem {
  id: number;
  title: string;
  heading: string;
  description: string;
  button_url: string;
  button_title: string;
}

export type FAQ = IElement & {
  heading: string;
  description: string;
  item_list: Array<QuestionItem>;
};

export const defaultQuestionItem: QuestionItem = {
  id: 0,
  title: "Geen vraag, geen antwoord",
  heading: "Hier komt een optionele titel",
  description:
    "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  button_url: "",
  button_title: "Externe link",
};

export const defaultFAQ: FAQ = {
  id: 0,
  name: ElementType.FAQ,
  heading: "Veel gestelde vragen over SEO",
  description: "Bellen en gebeld worden",
  item_list: [
    defaultQuestionItem,
    defaultQuestionItem,
    defaultQuestionItem,
    defaultQuestionItem,
  ],
};
